import(/* webpackMode: "eager" */ "/vercel/path0/src/app/resume/page.tsx");
